<template>
  <div
    class="table-responsive mt-5"
    style="min-height: 450px; padding: 0px 50px"
  >
    <Loader v-if="loading" />
    <div v-else>
      <div class="d-flex justify-content-start align-items-center mb-2" style="padding: 20px 0px; gap: 50px;">
        <div 
          class="search-div teal"
          @click="showSearchModal"
          style="cursor: pointer;"
        >
          <p style="line-height: 1; margin: 0; pointer-events: none;">
            送信一覧検索
          </p>
          <ContactSearch v-if="searchModal" />
        </div>
        <div class="calendar-filter-wrapper">
          <div 
            class="calendar-filter-btn"
            :class="{ 'active': showOnlyInterviewed }"
            @click="toggleInterviewFilter"
            title="面接実施のみ表示"
          >
            <i class="fa fa-calendar"></i>
          </div>
          <p class="calendar-label">面接実施絞込</p>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th style="width: 5%;"></th>
            <th style="width: 10%">送信日</th>
            <th style="width: 10%">登録/更新日</th>
            <th style="width: 15%;">氏名</th>
            <th style="width: 15%;">スカウト求人</th>
            <th class="text-center" style="width: 15%;">
              <b-dropdown
                id="response-dropdown"
                text="回答結果"
                variant="primary"
                class="m-2 th-dropdown"
                boundary="window"
                @hidden="resetResponseSelection"
                @shown="overflow"
              >
                <div>
                  <div
                    class="form-check form-check"
                    v-for="(response, index) in userResponses"
                    v-bind:key="index"
                  >
                    <input
                      type="checkbox"
                      :id="'response-' + index"
                      :value="response"
                      class="form-check-input"
                      v-model="tempUserResponseModel"
                    />
                    <label class="form-check-label">{{ response }}</label>
                  </div>
                  <div class="dropdown-separator"></div>
                  <div class="dropdown-footer">
                    <button class="btn-sm btn-primary ok-button" @click="applyResponseFilters">
                      OK
                    </button>
                  </div>
                </div>
              </b-dropdown>
            </th>
            <th class="text-center" style="width: 15%;">
              <b-dropdown
                id="status-dropdown"
                text="ステータス"
                variant="primary"
                class="m-2 th-dropdown"
                boundary="window"
                @hidden="resetStatusSelection"
                @shown="overflow"
              >
                <div>
                  <div
                    class="form-check form-check"
                    v-for="(status, index) in statusOptions"
                    v-bind:key="index"
                  >
                    <input
                      type="checkbox"
                      :id="'status-' + index"
                      :value="status"
                      class="form-check-input"
                      v-model="tempStatusModel"
                    />
                    <label class="form-check-label">{{ status }}</label>
                  </div>
                  <div class="dropdown-separator"></div>
                  <div class="dropdown-footer">
                    <button class="btn-sm btn-primary ok-button" @click="applyStatusFilters">
                      OK
                    </button>
                  </div>
                </div>
              </b-dropdown>
            </th>
            <th style="width: 15%;">差出人名</th>
            <th style="width: 10%;">面接実施</th>
          </tr>
        </thead>
        <tbody>
          <SentContactsRow
            v-for="(item, index) in sentContacts"
            :index="index"
            :key="item._id"
            :sentContact="item"
            :rowNumber="rowNumber(index)"
            :class="{ 'row-separator': (index + 1) % 10 === 0 }"
            @toggleInterview="handleInterviewToggle"
          />
        </tbody>
        <tr v-if="showEmptyContactMessage">
          <td colspan="100%" class="text-center">
            メッセージはありません
          </td>
        </tr>
      </table>

      <div class="pagination-area" v-if="totalPages > 0">
        <GlobalPaginate
          :total-page="totalPages"
          :callback="changePage"
          :currentPage="page"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import StatusBox from './StatusBox.vue';
import SentContactsRow from './SentContactsRow.vue';
import GlobalPaginate from '../../../utils/GlobalPaginate.vue';
import Loader from '../../../utils/Loader.vue';
import ContactSearch from './ContactSearch.vue';
export default {
  data() {
    return {
      tableData: [], // Initialize with an empty array,
      openProfile: null,
      // showSearchModal: false,
      // pagination: {},
      // page:1,
      // loading: false,
      params: {},
      overflowState: 0,
      showEmptyMessage: false,
      showOnlyInterviewed: false,
      userResponses: [
        '選考応募',
        'カジュアル面談',
        '面接参加',
        '質問',
        '応募見合わせ',
        '(通知のみ)',
      ],
      statusOptions: [
        '未判定',
        'スカウト対象',
        'スカウト対象外',
        '確認中',
        'スカウト済',
        '返信有',
        '応募有',
        'システム取込み済',
        '中長期対応',
        'その他',
      ],
      tempUserResponseModel: [],
      tempStatusModel: [],
      // userResponseModel: [],
    };
  },
  components: {
    StatusBox,
    SentContactsRow,
    GlobalPaginate,
    Loader,
    ContactSearch,
  },
  computed: {
    ...mapState({
      searchParams: (state) => state.individual_contact.sentSearchParams,
      page: (state) => state.individual_contact.sentPage,
      pagination: (state) => state.individual_contact.sentContactsPagination,
    }),
    ...mapGetters({
      sentContacts: 'getSentContacts',
      getClientStatus: 'getClientStatus',
      getSentStatusModel: 'getSentStatusModel',
      pagination: 'getSentContactsPagination',
      searchParams: 'getSentSearchParams',
      getUserResponseModel: 'getUserResponseModel',
      loading: 'getLoading',
      searchModal: 'getSearchModal',
    }),
    statusModel: {
      get() {
        return this.getSentStatusModel;
      },
      set(value) {
        this.setSentStatusModel(value);
      },
    },
    userResponseModel: {
      get() {
        return this.getUserResponseModel;
      },
      set(value) {
        this.setUserResponseModel(value);
      },
    },
    totalPages() {
      const { pagination } = this;
      // console.log(pagination.total
      //   ? Math.ceil(pagination.total / pagination.perPage)
      //   : 0);
      return pagination.total
        ? Math.ceil(pagination.total / pagination.perPage)
        : 0;
    },
    showEmptyContactMessage() {
      return this.sentContacts.length === 0;
    },
  },
  methods: {
    ...mapActions({ loadSentContacts: 'loadSentContacts' }),
    ...mapMutations([
      'setSentContacts',
      'setSentStatusModel',
      'setSentContactsPagination',
      'setLoading',
      'setSentPage',
      'setUserResponseModel',
      'toggleSearchModal',
    ]),
    showSearchModal() {
      this.toggleSearchModal(true);
    },
    overflow() {
      this.overflowState = 1;
      // Sync temp models with actual selected values when dropdown opens
      this.tempUserResponseModel = [...this.userResponseModel];
      this.tempStatusModel = [...this.statusModel];
    },
    applyResponseFilters() {
      this.setUserResponseModel([...this.tempUserResponseModel]);
      this.search();
    },
    applyStatusFilters() {
      this.setSentStatusModel([...this.tempStatusModel]);
      this.search();
    },
    resetResponseSelection() {
      // Reset temp selection to current actual selection
      this.tempUserResponseModel = [...this.userResponseModel];
    },
    resetStatusSelection() {
      // Reset temp selection to current actual selection
      this.tempStatusModel = [...this.statusModel];
    },
    showProfile(item) {
      this.openProfile = item.receiver._id;
    },
    // setPage(page){
    //     this.page = page
    // },
    rowNumber(index) {
      // console.log(index);
      return (
        index +
        1 +
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage
      );
    },
    changePage(page) {
      this.setSentPage(page);
    },
    filter() {
      const params = {};
      Object.assign(params, this.params);
      params.status = this.statusModel;
    },
    buildParams(page = null) {
      this.searchParams.status = this.statusModel;
      this.searchParams.user_response = this.userResponseModel;
      this.searchParams.showOnlyInterviewed = this.showOnlyInterviewed;
      const params = {
        ...this.searchParams,
        page: page || 1,
      };
      return params;
    },
    search() {
      this.loadSentMessages(this.buildParams(1));
    },
    async loadSentMessages(params = {}) {
      try {
        this.setLoading(true);
        let contacts = await this.loadSentContacts(params);
        let sentContacts = contacts.data.data;
        // this.pagination = contacts.data.meta.pagination;
        this.setSentContacts(sentContacts);
        this.setSentContactsPagination(contacts.data.meta.pagination);
        this.setLoading(false);
      } catch (err) {
        this.setLoading(false);
        console.log(err);
      }
    },
    handleInterviewToggle(data) {
      // Handle interview toggle event
      // You can add API call here to update the interview status
      // Example: this.updateInterviewStatus(data.contactId, data.interview);
    },
    toggleInterviewFilter() {
      this.showOnlyInterviewed = !this.showOnlyInterviewed;
      // Reload the list with the filter
      this.loadSentMessages(this.buildParams(1));
    },
  },
  mounted() {
    this.changeBodyToWhite();
  },
  async created() {
    await this.loadSentMessages(this.buildParams(1));
  },
    watch: {
    page: function(currentPage) {
      this.loadSentMessages(this.buildParams(currentPage));
    },
    searchParams: {
      handler(newParams) {
        if (newParams && Object.keys(newParams).length > 0) {
          // this.loading = true;  // Set loading to true before making the request
          this.loadSentMessages(this.buildParams(1));
          this.setSentPage(1);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
>>> .th-dropdown .btn {
  font-size: 18px !important;
  color: #006c6b !important;
  background-color: transparent !important;
  border: none !important;
}

table {
  table-layout: fixed !important;
  width: 100%;
  border-collapse: collapse !important;
}

table tbody tr {
  height: 80px !important;
  max-height: 80px !important;
  cursor: pointer;
}

table tbody tr:hover {
  border: 4px solid #026c6c !important;
}

.search-div {
  border: 1px solid #006c6b;
  background-color: #006c6b;
  padding: 14px 12px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  width: 200px !important;
  border-radius: 0px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-div p {
  margin: 0;
  color: #fff !important;
}

.calendar-filter-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.calendar-filter-btn {
  border: none;
  background-color: transparent;
  padding: 0px;
  color: #000000;
  text-align: center;
  font-size: 36px;
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.calendar-filter-btn:hover {
  opacity: 0.8;
}

.calendar-filter-btn.active {
  color: #dc3545;
}

.calendar-label {
  font-size: 14px;
  color: #000000;
  margin: 0;
  white-space: nowrap;
  font-weight: 700;
}

table th {
  text-align: center !important;
  color: #006c6b !important;
  font-size: 18px !important;
  border-bottom: 1px solid #e6e8ec !important;
  border-top: none !important;
  padding: 16px 8px !important;
  height: 60px !important;
}

table td {
  text-align: center !important;
  font-size: 16px !important;
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-top: 1px solid #e6e8ec !important;
  border-bottom: none !important;
  padding: 16px 8px !important;
  vertical-align: middle !important;
}

table thead tr {
  border-bottom: 1px solid #e6e8ec !important;
}

table tbody tr {
  border-top: 1px solid #e6e8ec !important;
}

.row-separator {
  border-bottom: 3px solid #e6e8ec !important;
}

/* Dropdown menu positioning fix for zoom */
.th-dropdown .dropdown-menu {
  max-height: 400px;
  overflow-y: auto;
  max-width: 300px;
}

.th-dropdown .dropdown-menu.show {
  min-width: 180px;
}

.dropdown-separator {
  border-top: 1px solid #e6e8ec;
  margin: 10px 0;
}

.dropdown-footer {
  display: flex;
  justify-content: center;
  padding: 3px 0 1px 0;
}

.ok-button {
  background-color: #62a4fd !important;
  border-color: #62a4fd !important;
  padding: 3px 18px;
  font-size: 13px;
  border-radius: 4px;
}

.ok-button:hover {
  background-color: #4a8ee4 !important;
  border-color: #4a8ee4 !important;
}
</style>
